import {RootState, SubscriptionsState} from '@/types';
import { GetterTree, MutationTree, ActionTree, Module } from 'vuex';


type SubscriptionsGetter = GetterTree<SubscriptionsState, RootState>;

export const initialState = (): SubscriptionsState => {
  return {
    initialState,
    layout: {
      headers: [],
      removedHeaders: [],
    },
  };
};

export const getters: SubscriptionsGetter = {
  layout: (state) => state.layout,
};

export const mutations: MutationTree<SubscriptionsState> = {
  setSubscriptionViewLayout(state, newLayout: { headers: Array<{[key: string]: string | boolean}>, removedHeaders: Array<{[key: string]: string | boolean}> }) {
    if (newLayout) {
      state.layout = newLayout;
    }
  },
};

export const actions: ActionTree<SubscriptionsState, RootState> = {

};


export const subscriptions: Module<SubscriptionsState, RootState> = {
  state: initialState(),
  getters,
  mutations,
  actions,
};
